import { getDefaultConfig } from '../base.js';

const envConfig = {
    subDomain: '',
    rootDomain: 'casino.stg.fndl.dev',
    internalNamespace: 'web-perf-fanduel-casino-use1',
    apis: {
        TransactionHistory: {
            baseUrl: 'https://api.statePlaceholder.stg.casino.fndl.dev'
        },
        CasinoSearchClient: {
            host: 'casino-search.stg.casino.fndl.dev',
            headers: {
                'x-api-key': '93rWzKosMj13MXqtdYRvS3L7bbjo3qYp7M1pEpAA'
            }
        }
    },
    services: {
        braze: {
            key: '8e6446fc-2d04-4b49-a241-cef9e4f346ce',
            product: 'FD-CASINO'
        },
        smartBanner: {
            id: 1506229470
        },
        ga: {
            authId: 'Mfgo4BsOA0qgX1cC0Mk9GA',
            preview: 'env-3'
        }
    },
    unifiedModules: {
        env: 'custom',
        clientId: '1022507da36a145a7421f28af3ee32eb',
        pxEnabled: false,
        customConfig: {
            api: 'https://api.stg.fndl.dev',
            web: 'https://account.statePlaceholder.casino.stg.fndl.dev'
        }
    }
};

export const config = getDefaultConfig(envConfig);
